import Reflux, { RefluxAction } from "reflux";
import { BundleWithQuantity } from "../utils/ListBulkSelectionUtils";

const exported = {
    setItemInCart: Reflux.createAction("setItemInCart") as RefluxAction<[string, number]>,
    changeAmountInCart: Reflux.createAction("changeAmountInCart") as RefluxAction<[string, number]>,
    handleBulkAddToBasket: Reflux.createAction("handleBulkAddToBasket") as RefluxAction<[BundleWithQuantity[]]>
};

export default exported;

export const { setItemInCart, changeAmountInCart, handleBulkAddToBasket } = exported;
